module.exports = __webpack_public_path__ + "img/cloudy.81bc945b.svg";